module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-ROSE-eng.3af7641f.png";